import React from "react";
import styles from '../styles.module.scss';
import TickSvg from "../../../components/svg/TickSvg";
import Try, {TryBtn} from "../../../components/Try";

export default function SolutionsA() {
  return <>
    <section className={styles.head}>
      <div className={styles.headContent}>
        <div className={styles.title}>
          <h4>股权链数据成为头部机构标配</h4>
          <h1>私募股权投资<br />解决方案</h1>
          <Try />
        </div>
        <div className={styles.sticker} style={{marginLeft: "137px"}}><img src="./static-official/images/sticker-s-a.png" height={552} alt="私募股权投资" /></div>
      </div>
    </section>
    <section className={styles.commonSection0}>
      <div className={styles.detailContainer}>
        <div className={styles.detailBlock} style={{width: "385px"}}>
          <h3>募投管退全流程数据工具</h3>
          <desc>依托全面的非上市公司数据库和一级市场投融资数据库，结合最新的大模型技术，打造了新一代私募股权投资数据工具，开箱即用，并支持数据同步本地。</desc>
          <ul>
            <li><h4><TickSvg />募资专区</h4></li>
            <li><h4><TickSvg />投资研究</h4></li>
            <li><h4><TickSvg />投后管理与赋能</h4></li>
            <li><h4><TickSvg />退出专区</h4></li>
          </ul>
          <TryBtn />
        </div>
        <img src="./static-official/images/s-a.png" alt="募投管退全流程数据工具" height={468}/>
      </div>
    </section>
  </>
}
